import ajax from '@/libs/api.request'

export default {
  getList:param=>{
    return ajax.get('edu/web/clazz/getList',param);
  },
  findOne:param=>{
    return ajax.get('edu/web/clazz/findOne',param);
  },
  save:param=>{
    return ajax.post('edu/web/clazz/save',param);
  },
  remove:param=>{
    return ajax.post('edu/web/clazz/delete',param);
  },
  getAvailableClass:param=>{
    return ajax.post('edu/web/clazz/getAvailableClass',param);
  },
  findClassRecord:param=>{
    return ajax.post('edu/web/clazz/findOneClassRecord',param);
  },
  finish:param=>{
    return ajax.post('edu/web/clazz/finish',param);
  },
  getInfo:param=>{
    return ajax.get('edu/web/clazz/getInfo',param);
  },
  getStudentList:param=>{
    return ajax.get('edu/web/clazz/getStudentList',param);
  },
  getStudentClassRecordList:param=>{
    return ajax.get('edu/web/clazz/getStudentClassRecordList',param);
  },
  studentStop:param=>{
    return ajax.post('edu/web/clazz/studentStop',param);
  },
  getScheduleList:param=>{
    return ajax.get('edu/web/clazz/getScheduleList',param);
  },
  getScheduleClassRecordList:param=>{
    return ajax.get('edu/web/clazz/getScheduleClassRecordList',param);
  },
  getClassRecordList:param=>{
    return ajax.get('edu/web/clazz/getClassRecordList',param);
  },
  getClassLogStudentList:param=>{
    return ajax.get('edu/web/clazz/getClassLogStudentList',param);
  },
  getAvailableMultiClass:param=>{
    return ajax.get('edu/web/clazz/getAvailableMultiClass',param);
  },
  getBeAddedStudentList:param=>{
    return ajax.get('edu/web/clazz/getBeAddedStudentList',param);
  },
  addStudent:param=>{
    return ajax.post('edu/web/clazz/addStudent',param);
  },
  cancelStudentOne:param=>{
    return ajax.post('edu/web/clazz/cancelStudentOne',param);
  },
  deleteStudentOne:param=>{
    return ajax.post('edu/web/clazz/deleteStudentOne',param);
  },
  setStudentHourNum:param=>{
    return ajax.post('edu/web/clazz/setStudentHourNum',param);
  },
  resetStudentHourNum:param=>{
    return ajax.post('edu/web/clazz/resetStudentHourNum',param);
  },
  transStudent:param=>{
    return ajax.post('edu/web/clazz/transStudent',param);
  },
  getTransTargetAvailableMultiClass:param=>{
    return ajax.get('edu/web/clazz/getTransTargetAvailableMultiClass',param);
  },
}
